export type UsageKey = 'subscriber' | 'vodTitle' | 'ltvChannel';

export interface LicenseRow {
  product: string;
  term: string;
  metric: string;
  limit: number;
  usageKey: UsageKey;
}

export interface LicenseCapacityWarning {
  license: LicenseRow;
  used: number;
  percent: number;
}

export type LicenseUsage = { [key in UsageKey]: number };

export const LICENSE_CAPACITY_WARNING_PERCENT = 80;

export const ATLAS_LICENSES: LicenseRow[] = [
  {
    product: 'ATLAS-360: Integration Gateway',
    term: 'perpetual', metric: 'per Subscriber', limit: 300000, usageKey: 'subscriber',
  },
  {
    product: 'ATLAS-CMS: Content Management System (VOD)',
    term: 'perpetual', metric: 'per VOD Title', limit: 12000, usageKey: 'vodTitle',
  },
  {
    product: 'ATLAS-CMS: Content Management System (Live TV)',
    term: 'perpetual', metric: 'per LTV Channel', limit: 150, usageKey: 'ltvChannel',
  },
  {
    product: 'ATLAS-CRM: Subscriber Management System',
    term: 'perpetual', metric: 'per Subscriber', limit: 300000, usageKey: 'subscriber',
  },
  {
    product: 'ATLAS-Compass: Recommendation & Search Engine Platform',
    term: 'perpetual', metric: 'per Subscriber', limit: 300000, usageKey: 'subscriber',
  },
];

export function readTotalElements(response: any): number {
  const body = response && response.body !== undefined ? response.body : response;
  return body && body.totalElements != null ? body.totalElements : 0;
}

export function buildLicenseCapacityWarnings(
  usage: LicenseUsage,
  warningPercent: number = LICENSE_CAPACITY_WARNING_PERCENT,
): LicenseCapacityWarning[] {
  return ATLAS_LICENSES
    .map((license) => {
      const used = usage[license.usageKey];
      return {
        license: license,
        used: used,
        percent: license.limit ? (used / license.limit) * 100 : 0,
      };
    })
    .filter((warning) => warning.percent >= warningPercent);
}
